<template>
  <div class="section-wrapper">
    <div class="sec2-trigger"></div>
    <!-- <div class="temporary-bg"></div> -->
    <div class="left-side sec-2-left-side">
      <div class="left-side-inner">
        <h2>Projektować po&nbsp;ludzku</h2>
        <p>
          Piękny design i&nbsp;zaawansowana technologia – to podstawa przy projektowaniu nowoczesnych sprzętów AGD. Jednak w&nbsp;tym procesie <strong>nie możemy zapominać o&nbsp;człowieku i&nbsp;jego rzeczywistych potrzebach.</strong>
        </p>
        <p>
          Przy rozwoju produktów przyświeca nam jeden nadrzędny <strong>cel – aby oferowane przez nas sprzęty AGD były użyteczne i&nbsp;pomocne w codziennym życiu. By były „dla ludzi”</strong> – wspierały w&nbsp;wyzwaniach, jakie przynosi każdy dzień, maksymalnie wyręczały i&nbsp;oszczędzały czas. Aby można było na nich polegać.
        </p>
        <p>
          By były <span class="splash-underline">„zaprojektowane po ludzku”</span>.
        </p>
      </div>
    </div>
    <div class="right-side sec-2-right-side">
      <div class="right-side-inner">
        <p>
          Dlatego <strong>Amica została strategicznym partnerem projektu Agory „ZAPROJEKTOWANE PO LUDZKU”</strong>, czyli jak w myśleniu o designie nie zgubić zwykłego człowieka. Jesteśmy również dumnym laureatem nagrody specjalnej, która uprawnia nas do stosowania znaku jakości „Zaprojektowane po ludzku”.
        </p>
        <a href="http://wyborcza.pl/AkcjeSpecjalne/7,166371,24032317,konkurs-zaprojektowane-po-ludzku.html" target="_blank" rel="noopener noreferrer">Dowiedz się więcej</a>
        <img :src="imageUrl" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    imageUrl: function () {
      return window.pageContentData.params.images['img-sec-2']
    }
  },
  mounted () {
    if (window.innerWidth > 1024) {
      const scene1 = this.$scrollmagic.scene({
        triggerElement: '.sec2-trigger',
        triggerHook: .2,
        duration: '100%',
      })

      scene1.setPin('.sec-2-left-side')

      this.$scrollmagic.addScene(
        scene1
          // .addIndicators()
      )

      const scene2 = this.$scrollmagic.scene({
        triggerElement: '.sec2-trigger',
        triggerHook: .2,
        duration: '100%',
      })

      scene2.setPin('.sec-2-right-side')

      this.$scrollmagic.addScene(
        scene2
          // .addIndicators()
      )

      // dot head, heart
      const scene3 = this.$scrollmagic.scene({
        triggerElement: '.sec2-trigger',
        triggerHook: .3,
        // duration: '100%',
        reverse: false
      })

      let Timeline = new TimelineMax();

      let bubbleScaleTween = TweenMax.to('.woman-big-dot', .6, {
        scale: 1,
      }, 1)

      let heartScaleTween = TweenMax.to('.woman-heart', 1, {
        scale: 1,
        ease: Elastic.easeOut
      }, 1)

      let bgDots1Tween = TweenMax.from('.bg-dots-1', 0.2, {
        xPercent: 1000,
        yPercent: -1000,
      }, 1)

      let bgDots2Tween = TweenMax.from('.bg-dots-2', 0.2, {
        xPercent: -1000,
        yPercent: 1000,
      }, 1)

      Timeline
        .add(bubbleScaleTween)
        .add(heartScaleTween)
        .add(bgDots1Tween)
        .add(bgDots2Tween)

      this.$scrollmagic.addScene(
        scene3
          .setTween(Timeline)
          // .addIndicators()
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    height: auto;
    padding: 15vw 0;
    position: relative;
    display: flex;

    @media only screen and (max-width : 1024px) {
      min-height: auto;
      height: auto;
      padding: 4rem 0;
    }

    @media only screen and (max-width : 768px) {
      flex-direction: column;
      padding: 2rem 0;
    }
    
    .temporary-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;

      background: url('../../../assets/images/zpl/bg-sec-2.jpg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      z-index: 0;
      pointer-events: none;
      display: none;

      @media only screen and (max-width : 1024px) {
        opacity: .08;
        display: block;
      }

      @media only screen and (max-width : 768px) {
        display: none;
      }
    }

    .left-side {
      // height: 100%;
      width: 50%;
      position: relative;

      @media only screen and (max-width : 768px) {
        width: 100%;
      }
      
      .left-side-inner {
        padding-left: 8.3333vw;
        height: 100%;
        width: 22.525vw;
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media only screen and (max-width : 1024px) {
          padding-left: 16.66%;
          width: 75.01%;
        }

        @media only screen and (max-width : 768px) {
          padding-left: 8.33%;
          padding-right: 8.33%;
          width: calc(100% - 8.33% - 8.33%);
          margin-bottom: 4rem;
        }
        
        h2 {
          color: #e41429;
          font-size: 3.2rem;
          margin-bottom: 4rem;
          font-weight: 600;

          @media only screen and (max-width : 1024px) {
            font-size: 2.2rem;
          }
        }

        p {
          font-size: 1rem;
          line-height: 1.7rem;

          span.splash-underline {
            display: inline-block;
            white-space: nowrap;
            position: relative;

            &:after {
              content: "";
              width: 80%;
              height: 80%;
              background: url('../../../assets/images/zpl/podkreslenie.svg');
              position: absolute;
              bottom: -100%;
              left: 10%;
              background-repeat: no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }

    .right-side {
      // height: 100%;
      width: 50%;
      position: relative;

      @media only screen and (max-width : 768px) {
        width: 100%;
      }

      .right-side-inner {
        padding-left: 16.66vw;
        width: 22.525vw;
        height: 100%;
        box-sizing: content-box;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: flex-start;

        transform: translateY(10%);

        @media only screen and (max-width : 1024px) {
          padding-left: 8.33%;
          width: 75.01%;
          transform: none;
        }

        @media only screen and (max-width : 768px) {
          padding-left: 8.33%;
          padding-right: 8.33%;
          width: calc(100% - 8.33% - 8.33%);
        }

        p {
          font-size: 1rem;
          line-height: 1.7rem;
        }

        a {
          background: -webkit-gradient(linear,left top,right top,from(#ae0b11),to(#e41429));
          background: linear-gradient(90deg,#ae0b11,#e41429);
          color: #fff;
          padding: 14px 30px;
          text-transform: uppercase;
          border-radius: 99px;
          display: inline-block;
          width: auto;
          margin-top: 1rem;

          &:hover {
            text-decoration: none;
          }

          @media only screen and (max-width : 768px) {
            margin: 1rem auto;
          }
        }

        img {
          border: 10px #fff solid;
          max-width: calc(22.525vw * 1.3);
          margin-top: 4rem;
          position: relative;
          z-index: 2;

          transform: translateX(-12.5%);

          @media only screen and (max-width : 1024px) {
            transform: none;
            margin-top: 2rem;
          }

          @media only screen and (max-width : 768px) {
            display: none;
          }
        }
      }

    }

  }
</style>